import React from 'react';

interface GridOverlayProps {
  enabled: boolean;
  size: number;
  color?: string;
}

const GridOverlay: React.FC<GridOverlayProps> = ({ enabled, size, color = '#e5e5e5' }) => {
  if (!enabled) return null;

  const patternId = 'grid-pattern';

  return (
    <svg
      className="absolute inset-0 pointer-events-none z-0"
      style={{ width: '100%', height: '100%' }}
    >
      <defs>
        <pattern
          id={patternId}
          width={size}
          height={size}
          patternUnits="userSpaceOnUse"
        >
          <path
            d={`M ${size} 0 L 0 0 0 ${size}`}
            fill="none"
            stroke={color}
            strokeWidth="0.5"
            opacity="0.3"
          />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill={`url(#${patternId})`} />
    </svg>
  );
};

export default GridOverlay;
